import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';

const Edit_foremen = (props) => {
  document.title = "Edit Foremen";
  const history = useHistory();
  const { postRequest } = useRequests();

  const [AlertData, setAlertData] = useState({ variant: '', message: '' });
  const [foremenData, setForemenData] = useState({
    name: "",
    username: "",
    email: "",
    mobile: ""
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData({ variant: '', message: '' });
    }, 5000);
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    username: Yup.string().required("Username is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    mobile: Yup.string()
      .required("Mobile Number is required")
      .matches(/^[0-9]+$/, "Mobile number must be digits only!")
      .test(
        "len",
        "Mobile number should be 9 digits for Spain/France/Belgium, 10 digits for other countries!",
        function (value) {
          if (!value) return false;
          return value.length === 9 || value.length === 10;
        }
      ),
  });

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: foremenData,
    validationSchema,
    onSubmit: async () => {
      try {
        const payload = {
          name: formik.values.name,
          username: formik.values.username,
          email: formik.values.email,
          mobile: formik.values.mobile,
        };
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';
        const jsonpar = JSON.stringify({
          f_id: atob(props.match.params.id),
          data: payload
        });
        const res = await postRequest('update-foremen', jsonpar);
        if (res && res.code === 200) {
          history.push({
            pathname: '/foremen_management',
            state: { code: 200, status: 'success', message: res.message }
          });
        } else {
          setAlertData({ variant: 'error', message: res.message });
        }
        resetAlertData();
        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setForemenData((prev) => ({ ...prev, [name]: value }));
    formik.setFieldValue(name, value);
  };

  const handleLoadGetForemenInfo = async () => {
    const jsonpar = JSON.stringify({
      f_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-foremen-info', jsonpar);
    if (res && res.code === 200 && res.data) {
      const newData = {
        name: res.data.name || "",
        username: res.data.username || "",
        email: res.data.email || "",
        mobile: res.data.mobile || ""
      };
      setForemenData(newData);
      formik.setValues(newData);
    } else {
      setAlertData({ variant: 'error', message: res.message });
      resetAlertData();
    }
  };

  useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/foremen_management',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
    } else {
      handleLoadGetForemenInfo();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      {AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Edit Foremen")} />
          <Card>
            <CardBody>
              <Row className="mt-3">
                <Col md={3}>
                  <div className="mb-3">
                    <Label className="form-label">Name :</Label>
                    <Input
                      name="name"
                      type="text"
                      placeholder="Enter Name"
                      value={formik.values.name}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.name && !!formik.errors.name}
                    />
                    {formik.touched.name && formik.errors.name && (
                      <FormFeedback type="invalid">{formik.errors.name}</FormFeedback>
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <div className="mb-3">
                    <Label className="form-label">Username :</Label>
                    <Input
                      name="username"
                      type="text"
                      placeholder="Enter Username"
                      value={formik.values.username}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.username && !!formik.errors.username}
                      disabled
                    />
                    {formik.touched.username && formik.errors.username && (
                      <FormFeedback type="invalid">{formik.errors.username}</FormFeedback>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <Label className="form-label">Email :</Label>
                    <Input
                      name="email"
                      type="email"
                      placeholder="Enter Email"
                      value={formik.values.email}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.email && !!formik.errors.email}
                      disabled
                    />
                    {formik.touched.email && formik.errors.email && (
                      <FormFeedback type="invalid">{formik.errors.email}</FormFeedback>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mb-3">
                    <Label className="form-label">Mobile Number :</Label>
                    <Input
                      name="mobile"
                      type="text"
                      placeholder="Enter Mobile Number"
                      value={formik.values.mobile}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.mobile && !!formik.errors.mobile}
                      disabled
                    />
                    {formik.touched.mobile && formik.errors.mobile && (
                      <FormFeedback type="invalid">{formik.errors.mobile}</FormFeedback>
                    )}
                  </div>
                </Col>
              </Row>
              <div className="text-left mt-2">
                <button
                  type="button"
                  id="submit1"
                  onClick={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                  }}
                  className="btn btn-primary me-2"
                >
                  Update
                </button>
                <Link to="/foremen_management" className="btn btn-light me-2">Cancel</Link>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Edit_foremen);
